import runScripts from 'views/assets/scripts/runScripts'

runScripts()
